var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.997 23.885c-0.318 0.277-0.518 0.682-0.518 1.134 0 0.828 0.672 1.5 1.5 1.5 0.396 0 0.756-0.154 1.024-0.404l-0.001 0.001 10-9c0.305-0.276 0.497-0.673 0.497-1.115s-0.191-0.839-0.495-1.114l-0.001-0.001-10-9c-0.262-0.228-0.606-0.367-0.982-0.367-0.828 0-1.5 0.672-1.5 1.5 0 0.432 0.183 0.822 0.476 1.096l0.001 0.001 8.76 7.885-8.76 7.885z"}));
}

RightArrow.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
